module.exports = __webpack_public_path__ + "img/answer_box.505e3b54.svg";